import * as React from "react";

function SvgSalescampCrm(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M0 17.94c0-1.309.565-2.554 1.55-3.415L15.16 2.615a4.537 4.537 0 015.976 0l13.612 11.91a4.537 4.537 0 011.55 3.414v15.524A4.537 4.537 0 0131.76 38H4.537A4.537 4.537 0 010 33.463V17.939z"
        fill="url(#SalescampCRM_svg__paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 1.494a4.526 4.526 0 012.839 1.12l13.611 11.91A4.537 4.537 0 0136 17.94v15.524A4.537 4.537 0 0131.463 38H18V1.494z"
        fill="url(#SalescampCRM_svg__paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 1.494a4.526 4.526 0 012.839 1.12l13.611 11.91A4.537 4.537 0 0136 17.94v15.524A4.537 4.537 0 0131.463 38H18V1.494z"
        fill="url(#SalescampCRM_svg__paint2_linear)"
        fillOpacity={0.4}
      />
      <defs>
        <linearGradient
          id="SalescampCRM_svg__paint0_linear"
          x1={18.149}
          y1={0}
          x2={18.149}
          y2={52.607}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0396FF" />
          <stop offset={1} stopColor="#197DD2" />
        </linearGradient>
        <linearGradient
          id="SalescampCRM_svg__paint1_linear"
          x1={17.851}
          y1={0}
          x2={17.851}
          y2={52.607}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0396FF" />
          <stop offset={1} stopColor="#197DD2" />
        </linearGradient>
        <linearGradient
          id="SalescampCRM_svg__paint2_linear"
          x1={27}
          y1={1.494}
          x2={27}
          y2={38}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default React.forwardRef(SvgSalescampCrm);
